import { Box, Button, Grid, styled } from "@mui/material";

export const TopGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#4EAF50",
  height: "80px",
  borderRadius: "4px",
  padding: "0px 20px",
  marginTop: "10px",
  [theme.breakpoints.down("md")]: {
    height: "150px",
  },
  [theme.breakpoints.down("sm")]: {
    height: "150px",
    padding: "0px 10px 0px 30px",
  },
}));

export const Header = styled(Box)(({ theme }) => ({
  zIndex: 1,
  position: "fixed",
  height: "100px",
  margin: "0px 10px",
  background: "#ebebeb",
  top: 0,
  left: 240,
  right: 0,
  [theme.breakpoints.down("sm")]: {
    left: 0,
  },
}));
export const BodyContainer = styled(Box)(({ theme }) => ({
  marginTop: "100px",
  [theme.breakpoints.down("md")]: {
    marginTop: "170px",
    // position: "relative",
    top: "50px",
  },
  [theme.breakpoints.down("sm")]: {
    marginTop: "230px",
    // position: "relative",
    top: "50px",
  },
}));
export const CenterBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
export const CBBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));
export const CbBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

export const ButtonAdd = styled(Button)({
  background: "white !important",
  color: "#4EAF50",
  display: "flex",
  justifyContent: "space-evenly",
  ml: "3px",
});
export const customStyles = {
  rows: {
    style: {
      minHeight: "42px",
      background: "white",
    },
  },
  header: {
    style: {
      // color: "#4EAF50",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#4EAF50",
      fontStyle: "normal",
      color: "#FFFFFF",
      fontWeight: "500",
      fontSize: "12px",
    },
  },
  cells: {
    style: {
      fontStyle: "normal",
      color: "#737373",
      fontWeight: "400",
      fontSize: "12px",
    },
  },
  table: {
    style: {
      background: "#EBEBEB",
      marginBottom: "20px",
    },
  },
};
export const BtnCancel = styled(Button)({
  backgroundColor: "#999 !important",
  textTransform: "none",
  color: "#fff",
});
